const getThemeStyles = (theme, requestedStyles = []) => {
  const styles = {}

  requestedStyles.forEach((style) => {
    switch (style) {
      case 'backgroundColor':
        styles.backgroundColor = theme.background_color
        break
      case 'backgroundImage': {
        styles.backgroundImage = `url(${theme.background_image})`
        break
      }
      case 'backgroundImageOpacity':
        styles.opacity = theme.background_image_opacity
        break
      case 'bodyFontSize':
        styles.fontSize = theme.body_font_size
        break
      case 'bodyFontWeight':
        styles.fontWeight = theme.body_font_weight
        break
      case 'bodyFontColor':
        styles.color = theme.body_font_color
        break
      case 'bodyFontFamily':
        styles.fontFamily = theme.body_font_family
        break
      case 'titleFontSize':
        styles.fontSize = theme.title_font_size
        break
      case 'titleFontWeight':
        styles.fontWeight = theme.title_font_weight
        break
      case 'titleFontColor':
        styles.color = theme.title_font_color
        break
      case 'titleFontFamily':
        styles.fontFamily = theme.title_font_family
        break
      default:
        break
    }
  })

  return styles
}

const getBackgroundStyles = (theme, overrides = {}) => {
  const backgroundStyleKeys = [
    'backgroundColor',
    'backgroundImageOpacity',
    'backgroundImage',
  ]
  const styles = getThemeStyles(theme, backgroundStyleKeys)

  if (overrides.backgroundImage) {
    styles.backgroundImage = `url(${overrides.backgroundImage})`
  }
  if (overrides.backgroundColor) {
    styles.backgroundColor = overrides.backgroundColor
  }
  if (overrides.opacity) {
    styles.opacity = overrides.opacity
  }

  Object.keys(styles).forEach((key) => !styles[key] && delete styles[key])

  return styles
}

const uploaderBackgroundColor = (theme) => {
  let color
  // Uploader background color is keyed off of content card.
  switch (theme.content_card_color) {
    case 'dark':
      color = '#000000'
      break
    case 'light':
      color = '#ffffff'
      break
    default:
      break
  }
  return color
}

const getUploaderStyles = (theme, requestedStyles = []) => {
  const styles = {}

  requestedStyles.forEach((style) => {
    switch (style) {
      case 'backgroundColor':
        styles.backgroundColor = uploaderBackgroundColor(theme)
        break
      default:
        break
    }
  })

  return styles
}

export { getBackgroundStyles, getThemeStyles, getUploaderStyles }

export default getThemeStyles
